













































import v8n from 'v8n';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { TotpResetConfirmation } from '@/api';

interface VuetifyForm extends Vue {
  validate: () => boolean;
}

@Component
export default class TotpResetConfirmationForm extends Vue {
  valid = false;

  loading = false;

  success = false;

  password = '';

  error = '';

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || this.$t('common.validation.generalRequired'),
  ];

  passwordRules = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || this.$t('users.validation.passwordRequired'),
  ];

  get uid() {
    return typeof this.$route.query.uid === 'string'
      ? this.$route.query.uid
      : '';
  }

  get token() {
    return typeof this.$route.query.token === 'string'
      ? this.$route.query.token
      : '';
  }

  get email() {
    return typeof this.$route.query.email === 'string'
      ? atob(this.$route.query.email)
      : '';
  }

  get queryOk() {
    return !!this.uid && !!this.token && !!this.email;
  }

  async reset2FA() {
    this.loading = true;
    try {
      const confirm = new TotpResetConfirmation({
        uid: this.uid,
        token: this.token,
        password: this.password,
      });
      await confirm.save();
      this.success = true;
    } catch (e) {
      this.error = (e as ErrorResponse).response.errors[0].detail || '';
    }
  }

  home() {
    this.$router.push({ name: 'login' });
  }

  @Watch('password')
  passwordChanged() {
    (this.$refs.form as VuetifyForm).validate();
  }
}
